document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header__inner');
  const megaMenuItems = document.querySelectorAll('.header__nav-link');

  megaMenuItems.forEach(item => {
    item.addEventListener('mouseenter', function () {
      megaMenuItems.forEach((el) => {
        const nextItem = el.nextSibling;
        if (nextItem) {
          const prevItem = nextItem.previousSibling;
          if (item !== prevItem) {
            setTimeout(() => {
              nextItem.classList.remove('active');
            }, 200);
          }
        }
      });
      const nextItem = item.nextSibling;
      if (nextItem) {
          setTimeout(() => {
            nextItem.classList.add('active');
          }, 200);
      }
    });
  });

  header.addEventListener('mouseleave', function () {
    megaMenuItems.forEach(item => {
      const nextItem = item.nextSibling;
      if (nextItem) {
        setTimeout(() => {
          nextItem.classList.remove('active');
        }, 800);
      }
    });
  });
});
